import { LogoMark } from "@/components/brand/logo";

/**
 * Global loader (route Suspense fallbacks + page containers): the brand mark
 * pulsing inside a thin spinning arc over a soft ambient glow — IronPipeline
 * redesign language instead of the old gray/blue spinner.
 */
const Loader = () => {
  return (
    <div className="flex h-screen w-full items-center justify-center">
      <div className="relative grid h-24 w-24 place-items-center">
        {/* Ambient glow */}
        <div className="absolute inset-0 rounded-full bg-brand-500/15 blur-2xl animate-pulse-soft" />

        {/* Static track */}
        <div className="absolute h-16 w-16 rounded-full border-2 border-white/[0.06]" />

        {/* Spinning arc */}
        <div
          className="absolute h-16 w-16 animate-spin rounded-full border-2 border-transparent border-t-brand-400 drop-shadow-[0_0_8px_rgba(59,130,246,0.55)]"
          style={{ animationDuration: "0.9s" }}
        />

        {/* Brand mark */}
        <LogoMark className="h-7 w-auto animate-pulse-soft" />
      </div>
    </div>
  );
};

export default Loader;
